import React, { useState } from 'react';
import { translate } from '@/services/TranslationService';
import { Typography } from '@/components/novoville';
import { Input } from '@/components/ui/input';

const RFInput = ({ value, onChange, error, ...props }) => {
  const [rfValue, setRfValue] = useState(value);

  const formatRFCode = (input) => {
    if (!input.startsWith('RF')) return input;
    const cleaned = input.replace(/\W/g, '').toUpperCase().slice(0, 29);
    return cleaned.match(/.{1,4}/g)?.join(' ') ?? '';
  };

  const handleChange = (e) => {
    const input = e.target.value;

    const formatted = formatRFCode(input);
    setRfValue(formatted);
    onChange?.(input);
  };

  return (
    <div className="flex flex-col max-w-96">
      <Typography variant={'semibold_14'} className="text-gray-800 mb-2">
        {translate('PaymentReferenceCode')}
      </Typography>
      <Input
        {...props}
        value={rfValue}
        // placeholder={translate('PaymentReferenceCode')}
        type="text"
        id="paymentCode"
        className={`w-full h-12 border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring focus:ring-blue-500 ${error ? 'border-red-500' : ''}`}
        onChange={handleChange}
      />
    </div>
  );
};

export default RFInput;
